export const EVENT_CHANNEL = 'navigation';
